import { useEffect, useState } from "react";
import moment from "moment";
import { Progress } from "antd";

import SessionService from "../../../../../../services/session/SessionService";
import { AccountWrapper, Avatar, Email, Information, Name, Operation, Operations, PhoneNumber, ProfileDetails, TenantName } from "./Account.styled";
import { BankOutlined, KeyOutlined, MailOutlined, MobileOutlined, PhoneOutlined, PoweroffOutlined, UserOutlined } from "@ant-design/icons";
import StringUtils from "../../../../../../util/StringUtils";
import { useNavigate } from "react-router-dom";

interface TaskListProps {

}

let Account: React.FC<TaskListProps> = (props)=> {
    // navigate
    let navigate = useNavigate();

    // data
    let profile = SessionService.getInstance().getCurrentUserProfile();

    let onSignOut = ()=> {
        SessionService.getInstance().setAuthorization('');
        window.location.href = '/';
    };

    let onUpdatePassword = ()=> {
        navigate('/profile/update-password');
    };

    // render
    return <AccountWrapper>
        <Information>
            <ProfileDetails>
                <TenantName><BankOutlined /> {profile.tenantName} </TenantName>
                <Name><UserOutlined /> {profile.name} </Name>
                <PhoneNumber><PhoneOutlined /> {StringUtils.emptyToDefault(profile.phoneNumber, "未填写手机号")} </PhoneNumber>
                <Email><MailOutlined /> {StringUtils.emptyToDefault(profile.email, '未填写电子邮箱')} </Email>
            </ProfileDetails>
        </Information>

        <Operations>
            <Operation onClick={onUpdatePassword}><KeyOutlined style={{paddingRight: "12px"}}/> 修改登录密码</Operation>
            <Operation onClick={onSignOut}><PoweroffOutlined style={{paddingRight: "12px"}}/> 退出当前登录</Operation>
        </Operations>
    </AccountWrapper>
};

export default Account;
